import { configureStore, Middleware } from "@reduxjs/toolkit";
import { OrderAdReducer } from "core/orderAd/orderAd.slice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AuthReducer } from "../core/auth/auth.slice";
import { ConfigsReducer } from "../core/configs/configs.slice";
import { OrdersListReducer } from "../core/ordersList/ordersList.slice";
import { NavigationReducer } from "../core/navigation/navigation.slice";
import { MembersCountReducer } from "core/membersCount/membersCount.slice";
import { AdPriceReducer } from "core/adPrice/adPrice.slice";
import { PeriodCapacityDataReducer } from "core/periodCapacityData/periodCapacityData.slice";
import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";
import { NPSReducer } from "core/nps/nps.slice";
import { TutorialsReducer } from "core/tutorials/tutorials.slice";
import { LuckyWheelReducer } from "core/luckyWheel/luckyWheel.slice";

const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({
    history: createBrowserHistory(),
  });

export const store = configureStore({
  reducer: {
    router: routerReducer as any,
    orderAd: OrderAdReducer,
    auth: AuthReducer,
    configs: ConfigsReducer,
    ordersList: OrdersListReducer,
    navigation: NavigationReducer,
    membersCount: MembersCountReducer,
    adPrice: AdPriceReducer,
    periodCapacityData: PeriodCapacityDataReducer,
    NPS: NPSReducer,
    tutorials: TutorialsReducer,
    LuckyWheel: LuckyWheelReducer,
  },

  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({ serializableCheck: false }).concat(
      routerMiddleware as any
    );
  },
});

export const history = createReduxHistory(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppSelector<T> = (state: RootState) => T;
